import { render } from "./Locations.vue?vue&type=template&id=5d5b927e&scoped=true&ts=true"
import script from "./Locations.vue?vue&type=script&lang=ts"
export * from "./Locations.vue?vue&type=script&lang=ts"

import "./Locations.vue?vue&type=style&index=0&id=5d5b927e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5b927e"]])

export default __exports__